import RenderManager from "../rendering/render-manager";
import CSlider from "circle-slider";
import * as Events from "../utils/events";
import Transition from "./Transition";
import Base2DElement from "./base-2d-element";


class CircleSlider extends Base2DElement {
    get position() { return { x: this.x, y: this.y } };
    
    constructor(options, parentLayer, uuid = THREE.Math.generateUUID()) {
        super(options, parentLayer, uuid)

        /* SPECIFIC 2D ELEMENTS PARAMETERS */
        this.y = options.y;
        this.x = options.x;
        //this.width = 300;
        this.options = options;

        this.tooltips = [
            {
                pos: { x: 34, y: 10 },
                text: "Tooltip Text"
            },
            {
                pos: { x: 65, y: 9 },
                text: "Tooltip Text"
            },
            {
                pos: { x: 92, y: 37 },
                text: "Tooltip Text"
            },
            {
                pos: { x: 93, y: 59 },
                text: "Tooltip Text"
            },
            {
                pos: { x: 73, y: 89 },
                text: "Tooltip Text"
            },
            {
                pos: { x: 62, y: 93 },
                text: "Tooltip Text"
            },
            {
                pos: { x: 42, y: 94 },
                text: "Tooltip Text"
            },
            {
                pos: { x: 26, y: 88 },
                text: "Tooltip Text"
            },
            {
                pos: { x: 8, y: 66 },
                text: "Tooltip Text"
            },
            {
                pos: { x: 8, y: 34 },
                text: "Tooltip Text"
            },
        ];

        // dom insertion
        this.className = 'drag-handler';

        // this.parentLayer.domElement.style.zIndex = 4;
        // this.createSliderElement();
        // this.domElement.appendChild(this.sliderElement);

        if (!Q3.layers) {
            Events.listen('assetsLoaded', () => { this.createSliderElement(); })
        } else {
            this.createSliderElement();
        }

        this.createRightSideBar();

        this.render(RenderManager.domElement.width / devicePixelRatio, RenderManager.domElement.height / devicePixelRatio);
    }

    _initValues(options) {
        this.type = "2DObject";
        this.type2d = "Cardiac Cycle";
        this.index = options.index;
        this.draggable = true;
    }

    _createContainer() {
        const container = super._createContainer();
        
        container.id = this.uuid;

        return container;
    }


    createRightSideBar() {
        this.rightArea = document.createElement("div");
        this.rightArea.className = "circle-slider-rightArea";
        this.rightArea.id = this.uuid + "-rightArea";
        this.rightArea.style.backgroundImage = 'url("/circleSlider/rightSide.jpg")';
        this.rightArea.style.paddingLeft = 'calc((100%*(9/16) - 55px)*0.5533)'; // 0.5533 hardcoded aspect of image.

        this.rightAreaDragger = document.createElement("div");
        this.rightAreaDragger.className = "circle-slider-rightAreaDragger ui-slider-handle";
        this.rightAreaDragger.className = 'ui-slider-handle';
        this.rightArea.appendChild(this.rightAreaDragger);
        $(this.rightArea).slider({
            value: 125,
            min: 0,
            max: 1000,
            step: 1,
            slide: (event, ui) => {
                const e = new CustomEvent('slide', { detail: ui.value });
                this.rightArea.dispatchEvent(e);
            }
        });
        this.parentLayer.domElement.appendChild(this.rightArea);
    }
    createTooltips() {
        this.tooltips.forEach((t) => {
            let tip = document.createElement("div");
            tip.className = "slider-tip";
            tip.style.top = t.pos.y + "%";
            tip.style.left = t.pos.x + "%";
            tip.innerHTML = `<div class="content">${t.text}</div>`
            this.sliderElement.appendChild(tip);
        });
    }

    createControls() {
        this.playBtn = document.createElement("p");
        this.playBtn.innerHTML = 'play_arrow';
        this.playBtn.title = 'Play';
        this.playBtn.className = 'material-icons play-pause';
        if (!Q3.editMode) {
            this.sliderElement.appendChild(this.playBtn);
        }

        this.playBtn.addEventListener("click", () => {
            if (this.isPlaying) {
                this.stop();
            } else {
                this.play();
            }
        })
    }

    createSliderElement() {
        setTimeout(() => {
            this.sliderElement = document.getElementById(this.uuid + "slider");
            if (!this.sliderElement) {
                this.sliderElement = document.createElement('div');
                this.sliderElement.className = "circle-slider-container";
                this.sliderElement.style.backgroundImage = 'url("/circleSlider/doughnut.png")';
                this.sliderElement.id = this.uuid + "slider";
                this.domElement.innerHTML = "";
                this.domElement.appendChild(this.sliderElement);

                this.createTooltips();

                this.createControls();

                this.slider = new CSlider(this.uuid + "slider", { startPos: "top", clockwise: true });
                this.slider.handle.addEventListener("mousedown", (e) => {
                    e.stopPropagation();
                    this.stop();
                });

                this.slider.on("sliderUp", (angle) => {
                    // this.disableDrag = false;
                    Events.fire('2d_param_changed');
                });

                this.rightArea.addEventListener('slide', (e) => {
                    let angle = Math.round((e.detail - 125) * 0.36);
                    this.slider.setAngle(angle);
                    this.stop();
                    Events.fire('2d_param_changed');
                });
                this.angle = 0;

                this.slider.on('sliderMove', (angle) => {
                    let r = Number((angle / 360).toFixed(3)) * 1000 + 125;
                    if (r > 1000) {
                        r = r - 1000;
                    }
                    $(this.rightArea).slider("value", r)
                });
                if (!Q3.editMode) {
                    let obj = Q3.assets.objects["BA4C409B-207B-422C-B0AA-45CFBC71A83D"] || Q3.assets.lights["BA4C409B-207B-422C-B0AA-45CFBC71A83D"]
                    const action = Q3.data.layers.layers2D[this.parentLayer.uuid].objects[this.uuid].action;
                    if (action) {
                        for (let i = 0; i < action.length; i++) {
                            const currAction = action[i];
                            let userAction = currAction.userAction;

                            //define a transition
                            const transition = new Transition(currAction.systemAction, currAction.value);

                            if (userAction == 'slide') {

                                this.slider.on('sliderMove', (angle) => {
                                    transition.slide(Number((angle / 360).toFixed(3)));
                                    if (obj) {
                                        // obj.rotation.y = obj.rotation.y + (Math.PI/360)*(this.angle > angle ? 1 : -1);
                                    }
                                    this.angle = angle;
                                });

                            } else if (userAction == 'click') {

                                this.domElement.addEventListener('mousedown', function (e) {

                                    transition.click();
                                }, false);
                            } else {

                            }
                        }
                    }
                }

                this.domElement.addEventListener('click', e => {
                  if (Q3.isSelecting2dObject) return;


                }, false);

            }
        }, 1)

    }

    delete() {

        this.parentLayer.objects.splice(this.parentLayer.objects.indexOf(this), 1);
        // this.parentLayer.domElement.removeChild(this.domElement);

        delete this.domElement;

        if (Q3.selected === this) {
            Q3.selected = null;
            Q3.Events.fire('selectchange');
        }

    }

    play() {
        this.playBtn.innerHTML = "pause";
        this.playBtn.title = "Pause";
        this.isPlaying = true;
        this.interval = setInterval(() => { this.angle++; this.slider.setAngle(this.angle); }, 10);
    }

    stop() {
        this.isPlaying = false;
        this.playBtn.title = "Play";
        this.playBtn.innerHTML = "play_arrow";
        clearInterval(this.interval)
    }
    draggableOnClick() {
        if (Q3.editMode) {
            Q3.selected = this;
            Events.fire('selectchange');
            RenderManager.activeCamera.update = true;
        }
    }

    render(width, height) {
        this.updateSize(width, height);

        if (!this.domElement) {
            this.domElement = document.getElementById(this.uuid);
        } else {
            this.domElement.style.position = "absolute";
            let { x, y } = this.position;
            this.domElement.style.top = y * 100 + "%";
            this.domElement.style.left = x * 100 + "%";

            if (Q3.editMode) {
                this.domElement.classList[Q3.selected === this ? "add" : "remove"]("is-selected")
            }
        }
    }

    updateSize(width, height) {
        if (!this.sliderElement) return;

        let { clientWidth, clientHeight } = this.sliderElement;
        this.width = clientWidth/width;
        this.height = clientHeight/height;
    }

    set position(pos) {
        let x = pos.x / 100;
        let y = pos.y / 100;
        this.x = x;
        this.y = y;
        Q3.data.layers.layers2D[this.parentLayer.uuid].objects[this.uuid].x = x;
        Q3.data.layers.layers2D[this.parentLayer.uuid].objects[this.uuid].y = y;
    }

    setData(data) {
        Object.assign(this, {
            x: data.x,
            y: data.y,
        });

        Object.assign(Q3.data.layers.layers2D[this.parentLayer.uuid].objects[this.uuid], {
            x: data.x,
            y: data.y,
        });

        RenderManager.activeCamera.update = true;
    }

}

export default CircleSlider;
export { CircleSlider };
